import { Col, Row, Spin } from 'antd';
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { getStyleVariableValue, truncateText } from '../../../../../utilz';

const renderLegendText = (value) => {
  return (
    <span
      style={{
        paddingLeft: '3px',
        verticalAlign: 'middle',
        color: getStyleVariableValue('--disabled-text'),
        lineHeight: '12px',
      }}
    >
      {value}
    </span>
  );
};

const CustomTooltip = ({ active, payload }) => {
  if (active && payload?.length) {
    const { city, stateName, countryName, pickup, delivery } = payload[0].payload;

    return (
      <Row className="state-tooltip px-16 py-10 d-flex flex-direction-column" align="middle">
        <Col>
          <h4 className="text-white mb-5">
            {city} - {stateName} ({countryName})
          </h4>
        </Col>
        <Col>
          <table>
            <tr>
              <td className="py-2 px-5">
                <div className="text-white">Origin:</div>
              </td>
              <td className="py-2 px-5">
                <div className="text-white">{pickup}</div>
              </td>
            </tr>
            <tr>
              <td className="py-2 px-5">
                <div className="text-white">Destination:</div>
              </td>
              <td className="py-2 px-5">
                <div className="text-white">{delivery}</div>
              </td>
            </tr>
          </table>
        </Col>
      </Row>
    );
  }

  return null;
};

const ClaimsStackedBarChart = ({ data = null }) => {
  return (
    <>
      {data?.length > 0 ? (
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            barCategoryGap="20%"
            margin={{
              top: 0,
              right: 0,
              left: 0,
              bottom: 35,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" vertical={false} />
            <XAxis
              dataKey="label"
              tick={{
                fontSize: 12,
                fill: getStyleVariableValue('--disabled-text'),
                fontWeight: 600,
              }}
              tickMargin={8}
              interval="equidistantPreserveStart"
              tickFormatter={(value) => truncateText(value, 12)}
              angle={-25}
              textAnchor="end"
            />
            <YAxis
              tick={{
                fontSize: 12,
                fill: getStyleVariableValue('--disabled-text'),
              }}
              width={40}
            />
            <Tooltip
              content={<CustomTooltip />}
              wrapperStyle={{
                backgroundColor: getStyleVariableValue('--dark'),
                border: 0,
                whiteSpace: 'nowrap',
                zIndex: 10,
              }}
            />
            <Legend
              verticalAlign="bottom"
              align="center"
              wrapperStyle={{
                right: 0,
                fontSize: 12,
                bottom: 3,
              }}
              formatter={renderLegendText}
              iconType="square"
              iconSize={12}
            />
            <Bar
              dataKey="pickup"
              name="Origin"
              stackId="a"
              fill={getStyleVariableValue('--iconSuccess')}
              barSize={18}
            />
            <Bar
              dataKey="delivery"
              name="Destination"
              stackId="a"
              fill={getStyleVariableValue('--iconDanger')}
              barSize={18}
            />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <Spin spinning={!data} />
      )}
    </>
  );
};

export default ClaimsStackedBarChart;
